// extracted by mini-css-extract-plugin
module.exports = {"index":"MarketIndex_index__39aX6","label":"MarketIndex_label__2k4HH","value":"MarketIndex_value__CHoB-"};